'use client';

import * as React from 'react';
import { LuInfo } from 'react-icons/lu';
import { Button } from '@core/ui/primitives/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@core/ui/primitives/dropdown-menu';

export interface MindmapInfoProps {
  className?: string;
}

export function MindmapInfo({ className }: MindmapInfoProps) {
  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant='outline' size='icon' aria-label='Mindmap info' className='hover:bg-muted'>
            <LuInfo className='h-4 w-4' />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end' sideOffset={8} className='w-[340px] max-h-[360px] overflow-auto p-2'>
          <DropdownMenuLabel>Mindmap Info</DropdownMenuLabel>
          <div className='px-2 py-1 text-sm text-muted-foreground'>
            <p className='mb-2'>
              All of your mind maps are saved locally in this browser. They are not synced across devices. Use export
              and import to move maps between machines.
            </p>
          </div>
          <DropdownMenuSeparator />
          <div className='px-2 py-1'>
            <div className='text-xs font-semibold text-muted-foreground mb-1'>Roadmap</div>
            <ul className='list-disc pl-5 text-sm space-y-1'>
              <li>Duplicate map action</li>
              <li>Reorder maps</li>
              <li>Optional cloud sync</li>
            </ul>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

export default MindmapInfo;
